module.exports = __webpack_public_path__ + "img/Phone.8374e0c5.png";